module.exports = __webpack_public_path__ + "UX35.png?a513f9f5454ce7befb7bd19cac6e1493";


//////////////////
// WEBPACK FOOTER
// ./src/assets/UX35.png
// module id = 85
// module chunks = 0